// Module
var code = "<div class=\"cr-chart\" ng-class=\"{ 'cr-mini': chartCtrl.mini }\"></div> ";
// Exports
export default code;